import styled from 'styled-components';
import { Button } from 'components/elements';

export const StyledParentalControlButton = styled(Button)`
	margin: 0 auto;
`;
